'use client';

import { T_Pool } from '@/ts/types/T_Pool';

import { calculateTokensRemaining } from './tokenDataUtils';
import { TokenStatsItem } from './TokenStatsItem';

interface I_TokenStatsProps {
  token: T_Pool;
  t: (key: string) => string;
}

export function TokenStats({ token, t }: I_TokenStatsProps) {
  const totalSupply = token.totalSupply;
  const tokensSold = token?.blockchainData?.totalSoldTokensDecimal || '0';
  const tokensRemaining = calculateTokensRemaining(token);
  const decimalsForFormatting = 2;

  return (
    <div className="grid gap-2">
      <TokenStatsItem
        label={t('tokensAvailable')}
        value={totalSupply}
        decimals={decimalsForFormatting}
      />
      <TokenStatsItem
        label={t('tokensSold')}
        value={tokensSold}
        decimals={decimalsForFormatting}
      />
      <TokenStatsItem
        label={t('tokensRemaining')}
        value={tokensRemaining}
        decimals={decimalsForFormatting}
      />
    </div>
  );
}
